import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/css/my.css";
import "assets/css/style.css";

import Homepage from "scenes/Homepage";

function App() {
  return (
    <div className="App">
      <Homepage></Homepage>
    </div>
  );
}

export default App;
